import { useCallback, useEffect, useState } from "react";

/** Tiny hash-based router: #/lobby?room=ABCD-EFGH */
export interface Route {
  page: string;
  params: URLSearchParams;
}

export function parseRoute(): Route {
  // primary: hash routes (#/lobby?room=X)
  if (window.location.hash) {
    const [path = "/", query = ""] = window.location.hash.replace(/^#/, "").split("?");
    return { page: path.replace(/^\//, "") || "home", params: new URLSearchParams(query) };
  }
  // fallback: path routes (/lobby?room=X) e.g. legacy bot links
  const page = window.location.pathname.replace(/^\//, "") || "home";
  return { page, params: new URLSearchParams(window.location.search) };
}

export function navigate(page: string, params?: Record<string, string>): void {
  const qs = params ? `?${new URLSearchParams(params).toString()}` : "";
  window.location.hash = `#/${page}${qs}`;
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(parseRoute);
  const onChange = useCallback(() => setRoute(parseRoute()), []);
  useEffect(() => {
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, [onChange]);
  return route;
}
